import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import authSlice from "./feature/authSlice";
import aboutusSlice from "./feature/aboutusSlice";
import {
  phoneSlice,
  addressSlice,
  projectSlice,
  serviceSlice,
  commentSlice,
} from "./feature";

const store = configureStore({
  reducer: {
    auth: authSlice,
    aboutus: aboutusSlice,
    phone: phoneSlice, // `phoneSlice` adını düzeltin
    address: addressSlice,
    project: projectSlice,
    service: serviceSlice,
    comments: commentSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

// Typed selector oluşturma
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
